import type { ReactElement } from 'react';
import type { TypographyProps } from '@mui/material';
import { Typography } from '@mui/material';
import { NoahLightIcon } from '@noah-labs/fe-shared-ui-assets/muiSvgIcons/NoahLightIcon';
import { TextWithIcon } from '@noah-labs/fe-shared-ui-components';
import type { PpWC } from '@noah-labs/fe-shared-ui-shared';

type PpTextWithNoahLogo = PpWC & {
  typographyColor?: TypographyProps['color'];
};

export function TextWithNoahLogo({
  children,
  typographyColor = 'text.dark',
}: PpTextWithNoahLogo): ReactElement {
  return (
    <TextWithIcon sx={{ paddingX: 0.5 }}>
      <NoahLightIcon color="primary" fontSize="xsmall" />
      <Typography color={typographyColor} variant="paragraphBodyS">
        {children}
      </Typography>
    </TextWithIcon>
  );
}
